<template>
  <span @click="download">
    <font-awesome-icon icon="arrow-down" fixed-width />   {{$t('buttons.download')}}</span>
</template>

<script>
  //import Vue from 'vue'
  export default {
    name: 'file-download-button',
    props: ['file'],
    methods: {
      download() {
        // console.log(this.file)
        //
         const downloadUrl =  window.baseURL + '/myfiles/download/' + this.file.id;



        if(this.file.owner == 'f' && this.file.file_type_id == 2) {
          //TODO: show popup
          //popupFactory('Warning', 'You are not allowed to download gcode files shared to you.', 1);
          return false;
        } else if (this.file_type_id == 6) {
          //TODO: show popup
          //var fileid = downloadUrl.substr( downloadUrl.lastIndexOf('/') + 1 );
          //txtReader(fileid);
        } else {
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.setAttribute('download', this.file.filename);
          document.body.appendChild(link);
          link.click();



          // Vue.axios({
          //   url: downloadUrl,
          //   method: 'GET',
          //   responseType: 'blob', // important
          // }).then((response) => {
          //   const url = window.URL.createObjectURL(new Blob([response.data]));
          //   const link = document.createElement('a');
          //   link.href = url;
          //   link.setAttribute('download', this.file.filename);
          //   document.body.appendChild(link);
          //   link.click();
          //
          //
          // });

        }
      }
    }
  }
</script>
